// extracted by mini-css-extract-plugin
export default {"tours-categories":"TourCategory_tours-categories__oC69j"};